import { render, staticRenderFns } from "./EJanPortal.vue?vue&type=template&id=1a832542&"
import script from "./EJanPortal.vue?vue&type=script&lang=ts&"
export * from "./EJanPortal.vue?vue&type=script&lang=ts&"
import style0 from "./EJanPortal.vue?vue&type=style&index=0&id=1a832542&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports